import { booleanAttribute, ChangeDetectionStrategy, Component, DestroyRef, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventTrackingService } from '@hyundai/ng-common-lib';
import { DEALER_THEME } from '@hyundai/shared-lib';
import { M010C020IconLinkComponent } from '@hyundai/ui';
import { DialogService } from '@pixelgenau/ngx-dialog';
import { switchMap } from 'rxjs';
import { SearchAboTag } from '../search-abo-overlay/search-abo.tag';

const SEARCH_ABO_SAVE_SEARCH_LABEL = 'Such-Abo: Suche speichern';

@Component({
    selector: 'lib-search-abo-button',
    imports: [M010C020IconLinkComponent],
    templateUrl: './search-abo-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export default class SearchAboButtonComponent {
    theme = input<DEALER_THEME | undefined>('light');
    dialogService = inject(DialogService);
    destroyRef = inject(DestroyRef);
    private readonly trackingService = inject(EventTrackingService);
    isBigButton = input(false, { transform: booleanAttribute });
    clicked = output();

    onClick = () => {
        this.trackingService.trackEngagementClick(SEARCH_ABO_SAVE_SEARCH_LABEL);
        this.clicked.emit();
        this.openSearchAboDialog();
    };

    openSearchAboDialog() {
        this.dialogService
            .openDialog(SearchAboTag)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                switchMap((result) => result.close$),
            )
            .subscribe();
    }
}
